/* BLOCKSAINTS Entry Gate (isolated, bar-only enter) */
(function(){
  var KEY = "bs_entered_v1";
  function qs(sel, root){ return (root||document).querySelector(sel); }
  function ready(fn){ if(document.readyState !== "loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }

  ready(function(){
    var gate = qs("[data-bs-entrygate]");
    if(!gate) return;

    try{
      if(window.sessionStorage && sessionStorage.getItem(KEY) === "1"){
        gate.parentNode && gate.parentNode.removeChild(gate);
        return;
      }
    }catch(e){}

    document.documentElement.classList.add("bs-entrygate-lock");
    document.body.classList.add("bs-entrygate-lock");

    function enter(){
      if(!gate) return;
      gate.classList.add("is-leaving");
      try{ if(window.sessionStorage) sessionStorage.setItem(KEY,"1"); }catch(e){}
      setTimeout(function(){
        try{
          document.documentElement.classList.remove("bs-entrygate-lock");
          document.body.classList.remove("bs-entrygate-lock");
        }catch(e){}
        gate.parentNode && gate.parentNode.removeChild(gate);
        gate = null;
      }, 380);
    }

    var slider = qs("[data-bs-slider]", gate);
    var fill   = qs("[data-bs-slider-fill]", gate);
    if(!slider || !fill) return;

    var dragging=false, rect=null, startX=0, rafId=0, pending=null;

    function apply(progress){
      progress = Math.max(0, Math.min(1, progress));
      fill.style.transform = "scaleX(" + progress + ")";
      if(progress >= 0.98){
        slider.classList.add("is-complete");
        enter();
      }else{
        slider.classList.remove("is-complete");
      }
    }

    function schedule(progress){
      pending = progress;
      if(rafId) return;
      rafId = requestAnimationFrame(function(){
        rafId = 0;
        if(pending != null) apply(pending);
        pending = null;
      });
    }

    function reset(){
      slider.classList.add("is-resetting");
      slider.classList.remove("is-complete");
      fill.style.transform = "scaleX(0)";
      setTimeout(function(){ slider.classList.remove("is-resetting"); }, 240);
    }

    function onDown(clientX){
      rect = slider.getBoundingClientRect();
      dragging = true;
      startX = clientX;
    }

    function onMove(clientX){
      if(!dragging || !rect) return;
      // progress measured from slider's left edge to pointer position
      var x = clientX - rect.left;
      var progress = x / rect.width;
      schedule(progress);
    }

    function onUp(){
      if(!dragging) return;
      dragging = false;
      if(!slider.classList.contains("is-complete")){
        reset();
      }
    }

    // Pointer events (mouse + touch)
    slider.addEventListener("pointerdown", function(e){
      e.preventDefault();
      onDown(e.clientX);
      try{ slider.setPointerCapture && slider.setPointerCapture(e.pointerId); }catch(err){}
    });

    slider.addEventListener("pointermove", function(e){
      onMove(e.clientX);
    }, {passive:true});

    slider.addEventListener("pointerup", function(){
      onUp();
    }, {passive:true});

    slider.addEventListener("pointercancel", function(){
      onUp();
    }, {passive:true});
  });
})();
